export default __webpack_public_path__ + "static/media/pdficon.f7f4aa8b.png";